import axios from 'axios';

import { TOKEN_KEY } from '../providers/logincontext';

const apiUrl = process.env.REACT_APP_API_URL;
export const API = axios.create({ baseURL: apiUrl });

API.interceptors.request.use(
  config => {
    const accessToken = localStorage.getItem(TOKEN_KEY);

    if (accessToken && config.headers) {
      config.headers['access-token'] = `${accessToken}`;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

API.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem('user');
      localStorage.removeItem('username');
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);
